var jQuery = require('jquery')
window.jQuery = jQuery
window.$ = jQuery
require('../node_modules/jquery/dist/jquery.min.js')
require('../node_modules/popper.js/dist/popper.min.js')
require('./assets/js/bootstrap.min.js')
require('./assets/js/jquery-filterable.js')
require('./assets/js/drift_code.js')
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import './assets/css/bootstrap.css'
import '../node_modules/slick-carousel/slick/slick.css'
import '../node_modules/animate.css'
import './assets/js/dl-menu/component.css'
import './assets/css/slick.css'
import './assets/css/font-awesome.min.css'
import './assets/css/svg.css'
import './assets/css/fullcalendar.css'
import './assets/css/shortcodes.css'
import './assets/css/widget.css'
import './assets/css/typography.css'
import './assets/css/style.css'
import './assets/css/responsive.css'
import './assets/css/color.css'

Vue.use(require('vue-script2'))



Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
